import { UseQueryOptions } from 'react-query'
import { getCurrentUser } from '../api/users'
import { User } from '../types'
import { checkGravatarExists } from './gravatar'

export const userQueryKeys = {
  me: ['users', 'me'],
  userHasGravatar: (email: string) => ['users', 'gravatar', email]
}

export const usersMeQuery: UseQueryOptions<User, Error> = {
  queryKey: userQueryKeys.me,
  queryFn: () => getCurrentUser(),
  staleTime: Infinity,
  retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000)
}

export const userHasGravatarQuery = (email: string) => ({
  queryKey: userQueryKeys.userHasGravatar(email),
  queryFn: () => checkGravatarExists(email),
  staleTime: Infinity
})
